var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticClass:"d-flex justify-content-between align-items-center",on:{"action":function($event){return _vm.$router.push({
    name: _vm.ROUTE_NAME_RESUME_ONE_CAMPAIGN,
    params : {
      campaign_id: _vm.item.id
    }
  })}}},[_c('span',{staticClass:"text-truncate pr-1"},[_c('strong',{staticClass:"pr-50"},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.startDateFormat)+" - "+_vm._s(_vm.endDateFormat)+")")])]),_c('b-list-group-item-button',{attrs:{"disable":"","color":"primary"}},[_c('i',{staticClass:"fa-solid fa-angle-right"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }